var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208.8 195.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.43,77.59v56.96c-1.2,5.93-5.44,9.55-11.5,9.95l-101.77-.02c-5.58-.58-9.78-4.43-10.79-9.93v-56.96l51.15,34.03c6.62,4.59,15.13,4.59,21.77,0l51.14-34.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.45,61.35v3.15c-.75,3.42-2.55,6.07-5.5,7.95-16.66,10.19-32.56,22.94-49.28,32.87-4.78,2.84-8.2,3.57-13.29.73l-52.94-35.52c-1.63-1.76-2.46-3.74-3.05-6.03.07-.85-.06-1.81-.03-2.67,0-.16.01-.32.03-.48.63-5.15,5.36-9.33,10.44-9.9.01,0,.02-.01.03-.01.11-.01.21-.02.32-.03h102.02c5.39.17,10.59,4.51,11.25,9.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.914c6cdcb9d64c10700e565718b2bd2f.svg";
export { ForwardRef as ReactComponent };